import {MdEmail} from 'react-icons/md'
import {BsMessenger} from 'react-icons/bs'
import {IoLogoWhatsapp} from 'react-icons/io'
import {FaYoutube} from 'react-icons/fa'




import './contact.css'


import Header from '../../components/Header'
import HeaderImage from '../../img/nation8.jpg'

const Contact = () => {
    return (
        <>
            <Header title="Contactez Nous" image={HeaderImage} >
                Nous serions ravis d'avoir de vos nouvelles ! N'hésitez pas à nous contacter pour toute question, demande d'information ou collaboration potentielle. Notre équipe dévouée est prête à vous aider et à répondre à vos besoins. Que ce soit par téléphone, par e-mail ou en remplissant le formulaire de contact ci-dessous, nous vous assurons une réponse rapide et un service de qualité. Contactez-nous dès aujourd'hui et laissez-nous faire de votre expérience une expérience exceptionnelle.
            </Header>
            <section className="  contact">
                <div className="container contact__wrapper">
                    <a href="mailto:sethagbaa@gmail.com" target='_blank' rel='noreferrer noopener' > { <MdEmail/>  } </a>
                    <a href="https://wa.me/+22890579946" target='_blank' rel='noreferrer noopener' > {<IoLogoWhatsapp/>}  </a>
                    <a href="https//m.me/seth.7" target='_blank' rel='noreferrer noopener' > {<BsMessenger />}  </a>
                    <a href="https://youtube.com/" rel="noreferrer noopener" target="_blank" > {<FaYoutube />} </a>

                </div>

            </section>
        </>
    )
}

export default Contact
